import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import styled from '@emotion/styled';
import { color, breakpoints } from '../../../utils/style';

const WrapperSection = styled('div')`
  padding: 10px 0;
  
`;

const StepsWrap = styled('div')`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  .step-block {
    position: relative;
    display: block;
    height: 190px;
    padding-right: 130px;
    &.a:hover, &.a:active {
      text-decoration: none;
      .delimeter-block img {
        filter: invert(63%) sepia(100%) saturate(396%) hue-rotate(357deg) brightness(95%) contrast(92%);
      }
      .content-wrap {
        color: ${color.darkRed};
        background: ${color.orange};
        &::after {
          border-left-color: ${color.orange};
        }
      }
      color: ${color.darkRed};
      cursor: pointer;
    }
  }
  .delimeter-block {
    background: ${color.midRed};
    width: 130px;
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    &::after {
      content: "";
      width:0;
      height:0;
      border: 60px solid transparent;
      border-left-color:  ${color.midRed};
      border-width: 95px 28px 95px 28px;
      position: absolute;
      right:-56px;
      top:0;
      z-index: 1;
    }
    .gatsby-image-wrapper {
      position: absolute;
      top: 46px;
      left: 58px;
    }
  }
  .content-wrap {
    position: relative;
    height: 100%;
    background: ${color.darkRed };
    &::after {
      content: "";
      width:0;
      height:0;
      border: 60px solid transparent;
      border-left-color:  ${color.darkRed};
      border-width: 95px 28px 95px 28px;
      position: absolute;
      right:-56px;
      top:0;
      z-index: 1;
    }
  }
  .no-desktop-arrow {
    padding-right: 0;
    &:after {
      display: none;
    }
  }
  @media (max-width: ${breakpoints.md}) {
    .step-block {
      padding-right: 24px;
      height: 74px;
    }
    .content-wrap {
      &::after {
        content: "";
        width:0;
        height:0;
        border: 30px solid transparent;
        border-left-color:  ${color.darkRed};
        border-width: 37px 12px 37px 12px;
        right:-24px;
        z-index: 0;
      }
    }
    .no-desktop-arrow {
      &:after {
        display: block;
      }
    }
  }
  
  
`;

const Step1Wrap = styled('div')`
  flex-basis: 36%;
  .content-wrap {
    padding: 20px 5px 20px 30px;
    border-radius: 15px 0 0 15px;
  }
  @media (max-width: ${breakpoints.md}) {
    flex-basis: 100%;
    margin-bottom: 10px;
    .content-wrap {
      padding: 7px 20px;
    }
  }
`;

const Step2Wrap = styled('a')`
  flex-basis: 36%;
  .content-wrap {
    padding: 20px 5px 20px 45px;
  }
  @media (max-width: ${breakpoints.md}) {
    flex-basis: 100%;
    margin-bottom: 10px;
    .content-wrap {
      border-radius: 15px 0 0 15px;
      padding: 7px 20px;
    }
  }
`;

const Step3Wrap = styled('a')`
  flex-basis: 28%;
  .content-wrap {
    padding: 20px 20px 20px 45px;
    border-radius: 0 15px 15px 0;
  }
  @media (max-width: ${breakpoints.md}) {
    flex-basis: 100%;
    .content-wrap {
      border-radius: 15px 0 0 15px;
      padding: 7px 20px;
    }
  }
`;

const StepNumberBlock = styled('div')`
  display: inline-block;
  vertical-align: top;
  margin-top: 22px;
  width: 90px;
  font-size: 70px;
  line-height: 1.2;
  @media (max-width: ${breakpoints.xl}) {
    font-size: 70px;
    width: 85px;
  }
  @media (max-width: ${breakpoints.md}) {
    font-size: 1.2rem;
    margin-top: 17px;
    width: 40px;
  }
`;

const TextBlock = styled('div')`
  font-size: 1.1rem;
  display: inline-block;
  width: calc(100% - 90px);
  padding-top: 10px;
  .step-title {
    font-size: 2rem;
    line-height: 1.1;
    display: block;
    margin-bottom: 10px;
  }
  @media (max-width: ${breakpoints.xl}) {
    font-size: 1.1rem;
    .step-title {
      font-size: 2rem;
    }
  }
  @media (max-width: ${breakpoints.lg}) {
    font-size: 14px;
    .step-title {
      font-size: 1.5rem;
    }
  }
  @media (max-width: ${breakpoints.md}) {
    font-size: 0.8rem;
    padding-top: 7px;
    width: calc(100% - 50px);
    .step-title {
      font-size: 1rem;
      margin-bottom: 5px;
    }
  }
  @media (max-width: ${breakpoints.xs}) {
    padding-top: 2px;
  }
`;

const DelimeterBlock = styled('div')`
  @media (max-width: ${breakpoints.md}) {
    display: none;
  }
`;

const Steps = () => (
  <StaticQuery
    query=
      {graphql`
        query {
          delimeter: file(relativePath: { eq: "steps-arrow-black.png" }) {
            childImageSharp {
              fixed(height: 96) {
                ...GatsbyImageSharpFixed
              }
            }
          }
        }
      `}
    render={data => (
      <WrapperSection>
        <StepsWrap>
          <Step1Wrap className="step-block">
            <div className="content-wrap">
              <StepNumberBlock className="step-number-block">
                <span className="step-number">1)</span>
              </StepNumberBlock>
              <TextBlock className="text-block">
                <span className="step-title">สมัครสมาชิก</span>
                <span className="step-details">เพียงไม่กี่ขั้นตอน ใช้เวลาไม่เกิน 2 นาที</span>
              </TextBlock>
            </div>
            {data.delimeter && data.delimeter.childImageSharp && data.delimeter.childImageSharp.fixed &&
            <DelimeterBlock className="delimeter-block">
              <Img alt="Delimeter" fixed={data.delimeter.childImageSharp.fixed}/>
            </DelimeterBlock>
            }
          </Step1Wrap>
          <Step2Wrap className="step-block a" href={process.env.URL + "/deposit/"}>
            <div className="content-wrap">
              <StepNumberBlock className="step-number-block">
                <span className="step-number">2)</span>
              </StepNumberBlock>
              <TextBlock className="text-block">
                <span className="step-title">ฝาก</span>
                <span className="step-details">ติกต่อฝ่าย Call Center เพื่อรับรายละเอียดช่องทางการฝากเงิน</span>
              </TextBlock>
            </div>
            {data.delimeter && data.delimeter.childImageSharp && data.delimeter.childImageSharp.fixed &&
            <DelimeterBlock className="delimeter-block">
              <Img alt="Delimeter" fixed={data.delimeter.childImageSharp.fixed}/>
            </DelimeterBlock>
            }

          </Step2Wrap>
          <Step3Wrap className="step-block a no-desktop-arrow" href={process.env.URL + "/gclub-download/"}>
            <div className="content-wrap no-desktop-arrow">
              <StepNumberBlock className="step-number-block">
                <span className="step-number">3)</span>
              </StepNumberBlock>
              <TextBlock className="text-block">
                <span className="step-title">สนุกกับเกม</span>
                <span className="step-details">รับ Username และ Password พร้อมเล่นเกมได้เลย</span>
              </TextBlock>
            </div>
          </Step3Wrap>
        </StepsWrap>
      </WrapperSection>
    )}
  />
);


export default Steps;